import {
  Constants,
  useMeeting,
  usePubSub,
} from "@videosdk.live/react-sdk";
import { useEffect, useRef, useState } from "react";
import PersonalDetails from "../pages/PersonalDetails";
import PolicyDetailsPage from "../pages/PolicyDetailsPage";
import VideoConsent from "../pages/VideoConsent";
import Thankyou from "../pages/Thankyou";
import Intropage from "../pages/Intropage";
import DisagreePage from "../pages/DisagreePage";
import Qna from "../pages/Qna";
import { useScreenshot } from "use-react-screenshot";
import { useAppContext } from "../AppContextDef";
import { logType, useJourney } from "../utils/common";
import { useTranslation } from "react-i18next";
import { toast, Bounce } from "react-toastify";
import useIsMobile from "../utils/useIsMobile";
import html2canvas from "html2canvas";
import useIsTab from "../utils/useIsTab";
import ConfirmDialog from "../components/ConfirmDialog";
import ClientPubSubHandler from "../components/ClientPubSubHandler";
import usePubsubFunction from "../utils/usePubsubFunction";
import useTimer from "../utils/useTimer";

const MeetingContainer = ({
  currentPage,
  setCurrentPage,
  referenceNo,
  screenShotRef,
  onDataSend,
}) => {
  const [joined, setJoined] = useState(null);
  const { endJourney, logJourney } = useJourney()
  const [characterJoined, setCharacterJoined] = useState(false);
  const [characterLeft, setCharacterLeft] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [image, takeScreenshot] = useScreenshot();
  const [userMessages, setUserMessages] = useState("");
  const [openErrorBox, setOpenErrorBox] = useState(false)
  // const [childData, setChildData] = useState("");
  const childDataRef = useRef(null);
  let isMobile = useIsMobile();
  const isTab = useIsTab();
  const { publish } = usePubSub(`ALL_DETAILS`);
  const { publish: publishCurrentPage } = usePubSub(`CURRENT_PAGE`);
  const { publish: timerDataPublish } = usePubSub("RUNNING_TIME_DATA");
  const { publish: langPublish } = usePubSub("SELECT_LANG");
  const { publish: abortSignalPublish } = usePubSub(`ABORT_SIGNAL`);
  const { publish: meetingLeftPublish } = usePubSub("ERROR_MEETING_LEFT");
  const { publish: journeyLimitPublish } = usePubSub("JOURNEY_LIMIT");
  const { publish: terminationStatusPublish } = usePubSub("TERMINATION_STATUS");
  const { publish: endJourneyAPIWaitingPublish } = usePubSub(
    "END_JOURNEY_API_WAITING",
  );
  const { updateJourney } = useJourney();
  const pubsubPublishMethod = usePubsubFunction()

  const { isOneMinuteLeft, setIsOneMinuteLeft } = useTimer()

  let isMobileOrTab = isMobile || isTab;
  const abortControllerRef = useRef(new AbortController());

  const completeProcess = () => {
    // Abort the current requests and create a fresh AbortController
    abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController(); // Replace with a new instance
  };

  useEffect(() => {
    pubsubPublishMethod(journeyLimitPublish, "Limit", { persist: true }, { showModal: isOneMinuteLeft })

  }, [isOneMinuteLeft])

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const accuracyRef = useRef(null);
  const mMeetingRef = useRef();

  const {
    allDetails,
    qna,
    journeyData,
    selectedLanguageCode,
    timer,
    setIsMeetingEnded,
    isMeetingEnded,
    suspectedFraud,
    setIsStartingJourneyClick,
    screenshots,
    setScreenshots,
    endApiCalledRef,
    currentPageRef,
    isRecorderNetworkUnstable,
  } = useAppContext();

  useEffect(() => {
    console.log("selectedLanguageCode", selectedLanguageCode);
    if (selectedLanguageCode) {
      pubsubPublishMethod(langPublish, selectedLanguageCode, { persist: true });
      changeLanguage(selectedLanguageCode);
    }
  }, [selectedLanguageCode]);

  useEffect(() => {
    pubsubPublishMethod(timerDataPublish, timer, { persist: true });
  }, [timer]);

  const handleChildData = (data) => {
    // setChildData(data);
    childDataRef.current = data;
  };

  const convertToJpeg = async (base64, quality = 0.7) => {
    const img = new Image();
    img.src = base64;

    await new Promise((resolve) => (img.onload = resolve));

    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    return canvas.toDataURL("image/jpeg", quality); // Convert to JPEG
  };

  const handleCapture = async () => {
    if (!screenShotRef.current) return;

    // Clone the entire parent div
    const cloneDiv = screenShotRef.current.cloneNode(true);
    cloneDiv.style.position = "absolute";
    cloneDiv.style.top = "0";
    cloneDiv.style.left = "-9999px"; // Move off-screen
    cloneDiv.style.overflow = "visible"; // Ensure that overflow is fully visible
    cloneDiv.style.maxWidth = "100vw";
    cloneDiv.style.width = "100%";
    cloneDiv.style.height = "auto";

    // Force full visibility for tab text
    const tabTexts = cloneDiv.querySelectorAll("p");
    tabTexts.forEach((el) => {
      el.style.whiteSpace = "normal"; // Prevent text from being truncated
      el.style.overflow = "visible";
    });


    // Fix the scrollable content inside the cloned div
    const scrollableDiv = cloneDiv.querySelector(".scrollable-content");
    if (scrollableDiv) {
      scrollableDiv.style.height = "auto"; // Ensure it doesn't get cut off
      scrollableDiv.style.overflow = "visible"; // No scroll clipping
    }

    // Handle sticky elements inside the cloned div
    const stickyElements = cloneDiv.querySelectorAll(".sticky");
    stickyElements.forEach((el) => (el.style.position = "static")); // Temporarily remove sticky

    // Convert videos to images inside the cloned div
    const videoElements = screenShotRef.current.querySelectorAll("video");
    await Promise.all(
      Array.from(videoElements).map(async (video, i) => {
        // Capture the current video frame
        const canvas = document.createElement("canvas");
        canvas.height = video.videoHeight;
        canvas.width = (video.videoHeight * 9) / 16;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert canvas to image
        const img = document.createElement("img");
        img.src = canvas.toDataURL("image/png");
        img.style.width = `${video.clientWidth}px`;
        img.style.height = `${video.clientHeight}px`;

        // Replace video with image inside the cloned div
        const clonedVideo = cloneDiv.querySelectorAll("video")[i];
        if (clonedVideo) clonedVideo.replaceWith(img);
      })
    );

    document.body.appendChild(cloneDiv); // Temporarily add to body

    // Wait for rendering to settle
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Capture the screenshot of the entire parent div with all elements
    const canvas = await html2canvas(cloneDiv, {
      scale: window.devicePixelRatio,
      width: cloneDiv.clientWidth,
      height: cloneDiv.clientHeight,
      scrollX: 0,
      scrollY: 0,
      windowWidth: cloneDiv.clientWidth,
      windowHeight: cloneDiv.clientHeight,
    });

    document.body.removeChild(cloneDiv); // Remove cloned div after capture

    return canvas.toDataURL("image/png");
  };

  const renderElementToCanvas = (element, context) => {
    const { left, top, width, height } = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    // Apply background color
    context.fillStyle = style.backgroundColor || "#fff";
    context.fillRect(left, top, width, height);

    // Apply border
    if (style.borderWidth !== "0px" && style.borderStyle !== "none") {
      context.strokeStyle = style.borderColor || "#000";
      context.lineWidth = parseFloat(style.borderWidth) || 1;
      context.strokeRect(left, top, width, height);
    }

    // Handle text content
    if (
      element.childNodes.length === 1 &&
      element.childNodes[0].nodeType === Node.TEXT_NODE
    ) {
      // context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      applyTextStyles(context, style);
      // context.fillStyle = style.color || "#000";
      // context.textAlign = style.textAlign || "left";
      // context.textBaseline = "top";

      context.fillText(
        element.textContent.trim(),
        left + parseFloat(style.paddingLeft),
        top + parseFloat(style.paddingTop)
      );
    }

    // Handle images
    if (element.tagName === "IMG") {
      const img = element;
      const { naturalWidth, naturalHeight } = img;
      const imgWidth = naturalWidth > width ? width : naturalWidth;
      const imgHeight = naturalHeight > height ? height : naturalHeight;
      context.drawImage(img, left, top, imgWidth, imgHeight);
    }

    // Handle videos
    if (element.tagName === "VIDEO") {
      const video = element;
      context.drawImage(video, left, top, width, height); // Draw the current video frame
    }

    // Recursively process child elements
    Array.from(element.children).forEach((child) => {
      renderElementToCanvas(child, context);
    });
  };

  const applyTextStyles = (context, style) => {
    // Apply font properties
    const fontStyle = style.fontStyle || "normal";
    const fontVariant = style.fontVariant || "normal";
    const fontWeight = style.fontWeight || "normal";
    const fontSize = style.fontSize || "16px";
    const fontFamily = style.fontFamily || "sans-serif";
    context.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize} ${fontFamily}`;

    // Apply text color
    context.fillStyle = style.color || "#000";

    // Apply text alignment
    context.textAlign = style.textAlign || "left";
    context.textBaseline = "top"; // Ensure text starts at the correct vertical position

    // Optional: Adjust for line height (if necessary)
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(fontSize);
    context.lineHeight = lineHeight; // Custom property (not native to canvas)
  };

  const getImage = async () => {
    // Skip if this page has already been captured (avoids re-capturing).
    if (screenshots.some(s => s.page === currentPage)) {
      return;
    }

    let img;

    if (isMobileOrTab) {
      img = await handleCapture();
    } else if (
      allDetails?.iciciApplicationDetails?.productDetails?.length > 1 &&
      currentPage === "PolicyDetails"
    ) {
      img = await handleCapture();
    } else {
      img = await takeScreenshot(screenShotRef.current);
    }

    const compressedImg = await convertToJpeg(img);

    const newScreenshot = {
      page: currentPage,
      screenshot: compressedImg
    };

    // Keep only the latest capture per page: drop any earlier one for this
    // page before appending the new one. Done inside the updater so it uses the
    // fresh `prev` (avoids the stale-closure race where two quick calls both
    // append a screenshot for the same page).
    setScreenshots(prev => {
      const updated = [
        ...prev.filter(s => s.page !== currentPage),
        newScreenshot,
      ];
      updateJourney({ screenshots: updated });
      return updated;
    });
  };


  const meetingConnectionFailedJourney = async () => {
    await endJourney({
      journeyStatus: "MEETING_CONNECTION_FAILED",
    });
    onDataSend("en");
    mMeetingRef?.current?.end();
    window.location.reload();

  };

  const handleCharacterLeft = async () => {
    setCharacterLeft(true)
    pubsubPublishMethod(meetingLeftPublish, "Meeting_left", { persist: true }, { open: true });
    setOpenErrorBox(true)
  };

  const _handleOnMeetingStateChanged = (data) => {
    const { state } = data;

    if (state === "DISCONNECTED" || state === "RECONNECTING") {

      if (!endApiCalledRef.current) {
        new Audio(
          `https://cdn.videosdk.live/icici/error_1.wav`
        ).play();
        toast.error(`${t("Meeting connection failed")}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        meetingConnectionFailedJourney();

      }
    }
    // else if (state === "RECONNECTING") {
    //   new Audio(
    //     `https://cdn.videosdk.live/icici/error_1.wav`
    //   ).play();
    //   toast.error(`${t("Meeting connection disconnected abruptly")}`, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //   });
    // }
  };

  function onRecordingStateChanged(data) {
    const { status } = data;

    if (status === Constants.recordingEvents.RECORDING_STARTED && currentPageRef.current === "Intro") {
      setIsStartingJourneyClick(false);
      setCurrentPage("PersonalDetails");
    }

  }

  const handleAgree = () => {
    completeProcess();
    pubsubPublishMethod(abortSignalPublish, "Abort", { persist: true }, { isAbort: true });

    if (currentPage === "PersonalDetails") {
      setCurrentPage("PolicyDetails");
    } else if (currentPage === "PolicyDetails") {
      setCurrentPage("VideoConsent");
    } else if (currentPage === "QnA") {
      setCurrentPage("Thankyou");
    }
  };

  const handleDisagreeAPI = async (disagreeReason) => {
    let journeyStatus =
      currentPage === "PersonalDetails"
        ? "USER_DISAGREED_TO_PERSONAL_DETAILS"
        : currentPage === "PolicyDetails"
          ? "USER_DISAGREED_TO_POLICY_DETAILS"
          : "";

    await endJourney({
      journeyStatus: journeyStatus,
      disagreeReason: disagreeReason,
    });
  };

  const handleDisagree = () => {
    pubsubPublishMethod(publishCurrentPage, "Page", { persist: true }, { message: "Disagree" });
    setCurrentPage("Disagree");
  };

  const handleVideoConsentSuccess = () => {
    // Show QnA only when we have at least one question; else skip to Thankyou (hide empty QnA section)
    if (allDetails?.qnaTemplateId && Array.isArray(qna) && qna.length > 0) {
      setCurrentPage("QnA");
    } else {
      setIsMeetingEnded(true);
      pubsubPublishMethod(publishCurrentPage, "Page", { persist: true }, { message: "Disagree" });
      setCurrentPage("Thankyou");
    }
  };

  // ---- Action-on-Failure: SUSPECTED_FRAUD auto-termination ----------------
  // ClientPubSubHandler folds the recorder's verdict stream into journey-wide
  // counters and trips `suspectedFraud` on breach. Run the teardown exactly once:
  // flag the recorder's soft "representative will contact you" screen, end the
  // journey as SUSPECTED_FRAUD, tear down the room (stops recording + polling)
  // and show the same soft screen on the customer side.
  const suspectedFraudHandledRef = useRef(false);
  const handleSuspectedFraud = async (reason) => {
    console.log(
      `%c 🚨 SUSPECTED_FRAUD %c ${reason} — starting teardown `,
      "color:#fff;background:#b91c1c;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:bold",
      "color:#b91c1c;background:#fee2e2;padding:2px 6px;border-radius:0 3px 3px 0;font-weight:bold",
    );
    logJourney({
      type: logType.ACTION,
      message: `Journey auto-terminated: SUSPECTED_FRAUD (${reason})`,
    });
    pubsubPublishMethod(
      terminationStatusPublish,
      "TERMINATED",
      { persist: true },
      { showTerminationMessage: true },
    );
    const status = await endJourney({ journeyStatus: "SUSPECTED_FRAUD" });
    console.log(
      `%c SUSPECTED_FRAUD %c endJourney → ${status}${status === 200 ? " · ending meeting now" : " · NOT ending (non-200)"} `,
      "color:#fff;background:#b91c1c;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:bold",
      "color:#374151;background:#f3f4f6;padding:2px 6px;border-radius:0 3px 3px 0",
    );
    if (status === 200) {
      pubsubPublishMethod(
        endJourneyAPIWaitingPublish,
        "journeyend",
        { persist: true },
        { isJourneyEnd: false },
      );
      sessionStorage.setItem("showTerminationMessage", "true");
      setIsMeetingEnded(true);
      mMeetingRef?.current?.end();
      setCurrentPage("Thankyou");
    }
  };

  useEffect(() => {
    if (suspectedFraud && !suspectedFraudHandledRef.current) {
      suspectedFraudHandledRef.current = true;
      handleSuspectedFraud(suspectedFraud.reason);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suspectedFraud]);

  const mMeeting = useMeeting({
    onMeetingStateChanged: _handleOnMeetingStateChanged,
    onRecordingStateChanged: onRecordingStateChanged,
    onCharacterLeft: handleCharacterLeft,
    onError: ({ code }) => {
      if (code === "4011" || code === "5001") {
        pubsubPublishMethod(meetingLeftPublish, "Meeting_left", { persist: true }, { open: true });
        setOpenErrorBox(true)
      }
    }
  });

  useEffect(() => {
    mMeetingRef.current = mMeeting;
  }, [mMeeting]);

  useEffect(() => {
    if (allDetails && currentPage === "PersonalDetails") {
      // journeyId rides along because the recorder writes IDENTITY logs and the
      // LOGS row needs it — it is the only key the dashboard filters logs by,
      // and /journey/start (the only place it comes from) is client-side.
      pubsubPublishMethod(publish, "Details", { persist: true }, { message: allDetails, qna, journeyId: journeyData?.journeyId });
      pubsubPublishMethod(publishCurrentPage, "Page", { persist: true }, { message: "PersonalDetails" });
    } else {
      pubsubPublishMethod(publishCurrentPage, "Page", { persist: true }, { message: currentPage });
    }
  }, [allDetails, currentPage]);

  useEffect(() => {
    if (isMeetingEnded) {
      completeProcess();
    }
  }, [isMeetingEnded]);

  return (
    <>
      {joined === "JOINED" && <ClientPubSubHandler />}
      {currentPage === "PersonalDetails" && joined === "JOINED" && (
        <PersonalDetails
          handleAgree={handleAgree}
          handleDisagree={handleDisagree}
          joined={joined}
          currentPage={currentPage}
          characterJoined={characterJoined}
          setCharacterJoined={setCharacterJoined}
          capturedImage={capturedImage}
          setCapturedImage={setCapturedImage}
          getScreenshotImage={getImage}
          handleDisagreeAPI={handleDisagreeAPI}
          abortSignal={abortControllerRef.current}
        />
      )}
      {currentPage === "PolicyDetails" && (
        <PolicyDetailsPage
          handleAgree={handleAgree}
          handleDisagree={handleDisagree}
          currentPage={currentPage}
          characterJoined={characterJoined}
          capturedImage={capturedImage}
          setCapturedImage={setCapturedImage}
          getScreenshotImage={getImage}
          handleDisagreeAPI={handleDisagreeAPI}
          abortSignal={abortControllerRef.current}
        />
      )}
      {currentPage === "VideoConsent" && (
        <VideoConsent
          handleVideoConsentSuccess={handleVideoConsentSuccess}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          characterJoined={characterJoined}
          capturedImage={capturedImage}
          setCapturedImage={setCapturedImage}
          getScreenshotImage={getImage}
          screenShotRef={screenShotRef}
          userMessages={userMessages}
          setUserMessages={setUserMessages}
          accuracyRef={accuracyRef}
          abortSignal={abortControllerRef.current}
        />
      )}
      {currentPage === "Disagree" && (
        <DisagreePage setCurrentPage={setCurrentPage} />
      )}
      {currentPage === "Thankyou" && <Thankyou />}
      {currentPage === "Intro" && (
        <Intropage
          setJoined={setJoined}
          setCurrentPage={setCurrentPage}
          joined={joined}
          referenceNo={referenceNo}
          handleChildData={handleChildData}
          onDataSend={onDataSend}
        />
      )}
      {currentPage === "QnA" && (
        <Qna
          handleAgree={handleAgree}
          handleDisagree={handleDisagree}
          currentPage={currentPage}
          capturedImage={capturedImage}
          setCapturedImage={setCapturedImage}
          getScreenshotImage={getImage}
          screenShotRef={screenShotRef}
          abortSignal={abortControllerRef.current}
        />
      )}
      {openErrorBox && (
        <ConfirmDialog
          open={openErrorBox}
          setOpen={setOpenErrorBox}
          text={t(
            "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]"
          )}
          buttonText={t("Close")}
          buttonHandler={async () => {
            pubsubPublishMethod(meetingLeftPublish, "Meeting_Left", { persist: true }, { open: false });
            await logJourney({
              type: logType.ERROR,
              message: `PIVV failed because ${characterLeft ? "character left the meeting" : "recording failed"}`,
            });
            await endJourney({
              journeyStatus: "MEETING_CONNECTION_FAILED",
            });
            onDataSend("en");
            mMeetingRef?.current?.end();
            window.location.reload()

          }}
        />
      )}
      {isOneMinuteLeft && (
        <ConfirmDialog
          open={isOneMinuteLeft}
          setOpen={setIsOneMinuteLeft}
          title={t("Session Expiring Soon")}
          text={t(
            "Your journey is about to expire in one minute. Please complete any pending actions."
          )}
          buttonText={t("Close")}
          buttonHandler={async () => {
            setIsOneMinuteLeft(false)
          }}
        />
      )}
      {/* Recorder-observed network instability — blocking dialog shown on every
          page; auto-dismisses when the recorder reports recovery. */}
      {isRecorderNetworkUnstable && (
        <ConfirmDialog
          open={isRecorderNetworkUnstable}
          showButton={false}
          text={t(
            "Your network connection is unstable and too weak to continue. Please switch to a better network to resume the session."
          )}
        />
      )}
    </>
  );
};

export default MeetingContainer;
